module.exports = __webpack_public_path__ + "img/left-main.ff578495.png";